import { Cart } from "@/interfaces";
import { CartHelper } from "@/helpers";
import * as S from "./styles";
import { Button } from "@mui/material";

export type ProductCartHeaderProps = {
  cart?: Cart;
  onShipAll?: () => void;
};

const ProductCartHeader: React.FC<ProductCartHeaderProps> = ({
  cart = undefined,
  onShipAll,
}) => {
  // Only show if there are in-store items
  const hasInStoreItems = !!cart && Array.isArray(cart.products) && cart.products.length > 0;
  if (!hasInStoreItems) return null;
  return (
    <S.ProductCartHeaderContainer>
      <S.ProductCartHeaderLabel>In-Store Items</S.ProductCartHeaderLabel>
      {onShipAll && (
        <Button
          variant="outlined"
          size="small"
          sx={{ ml: 2, fontWeight: 500, fontSize: 16, borderRadius: 2, textTransform: 'none' }}
          onClick={onShipAll}
        >
          Ship All Items
        </Button>
      )}
    </S.ProductCartHeaderContainer>
  );
};

export default ProductCartHeader;
